<template>
    <div :class="['step', 'no-padding', 'parameters-' + type]">
        <div class="step-header d-none d-md-block">
            <div class="svg-icon"
                 :style="'mask: url(/img/icons/house-design.svg); -webkit-mask-image: url(/img/icons/house-design.svg);'"></div>
            {{ $t('titles.disposition') }}
        </div>
        <div class="row">
            <div v-if="type === 'flat'" class="col-md-6" :key="1">
                <div class="form-group row align-items-center">
                    <label
                        for="floor_area"
                        class="font-weight-medium col-lg-6"
                    >
                        {{ $t('disposition.floor_area') }}
                        <sup class="text-danger">*</sup>
<!--                        <i class="fas fa-question-circle text-primary ml-1"-->
<!--                           data-toggle="tooltip"-->
<!--                           :title="$t('disposition.help.floor_area_flat')">-->
<!--                        </i>-->
                        <tooltip :title="$t('disposition.help.floor_area_flat')"></tooltip>
                    </label>
                    <div class="input-group col-lg-6">
                        <input id="floor_area" class="form-control border-radius-0-right" min="0.01" step="0.01" type="number"
                               name="floor_area" v-on:focus="setPicture('floor')" v-model="floorArea" required>
                        <div class="input-group-append">
                            <span class="input-group-text">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label for="balcony_area" class="col-lg-6">{{ $t('disposition.balcony') }}</label>
                    <div class="input-group col-lg-6">
                        <input id="balcony_area" class="form-control border-radius-0-right" min="0.01" step="0.01" type="number"
                               name="balcony_area" v-on:focus="setPicture('balcony')" v-model="balconyArea">
                        <div class="input-group-append">
                            <span class="input-group-text">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label for="garden_area" class="col-lg-6">{{ $t('disposition.garden') }}</label>
                    <div class="input-group col-lg-6">
                        <input id="garden_area" class="form-control border-radius-0-right" min="0.01" step="0.01" type="number"
                               name="garden_area" v-on:focus="setPicture('garden')" v-model="gardenArea">
                        <div class="input-group-append">
                            <span class="input-group-text">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="cellar_area" class="col-lg-6">{{ $t('disposition.cellar') }}</label>
                    <div class="input-group col-lg-6">
                        <input id="cellar_area" class="form-control border-radius-0-right" min="0.01" step="0.01" type="number"
                               name="cellar_area" v-on:focus="setPicture('cellar')" v-model="cellarArea">
                        <div class="input-group-append">
                            <span class="input-group-text">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="type === 'land'" class="col-md-6">
                <div class="form-group row align-items-center">
                    <label for="lot_area" class="required font-weight-medium col-lg-6">{{ $t('disposition.lot_area') }}</label>
                    <div class="input-group col-lg-6">
                        <input id="lot_area" class="form-control border-radius-0-right" min="0.01" step="0.01" type="number"
                               name="lot_area" v-on:focus="setPicture('lot')" v-model="lotArea" required>
                        <div class="input-group-append">
                            <span class="input-group-text">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="col-md-6" :key="2">
                <div class="form-group row align-items-center">
                    <label
                        for="floor_area"
                        class="font-weight-medium col-lg-6"
                    >
                        {{ $t('disposition.floor_area') }}
                        <sup class="text-danger">*</sup>
                       <tooltip :title="$t('disposition.help.floor_area_other')"></tooltip>
                    </label>
                    <div class="input-group col-lg-6">
                        <input id="floor_area" class="form-control border-radius-0-right" min="0.01" step="0.01" type="number"
                               name="floor_area" v-on:focus="setPicture('floor')" v-model="floorArea" required>
                        <div class="input-group-append">
                            <span class="input-group-text">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="cellar_area" class="col-lg-6">{{ $t('disposition.cellar') }}</label>
                    <div class="input-group col-lg-6">
                        <input id="cellar_area" class="form-control border-radius-0-right" min="0.01" step="0.01" type="number"
                               name="cellar_area" v-on:focus="setPicture('cellar')" v-model="cellarArea">
                        <div class="input-group-append">
                            <span class="input-group-text">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="garage_area" class="col-lg-6">{{ $t('disposition.garage') }}</label>
                    <div class="input-group col-lg-6">
                        <input id="garage_area" class="form-control border-radius-0-right" min="0.01" step="0.01" type="number"
                               name="garage_area" v-on:focus="setPicture('garage')" v-model="garageArea">
                        <div class="input-group-append">
                            <span class="input-group-text">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="other_area" class="col-lg-6">{{ $t('disposition.other_area') }}</label>
                    <div class="input-group col-lg-6">
                        <input id="other_area" class="form-control border-radius-0-right" min="0.01" step="0.01" type="number"
                               name="other_area" v-on:focus="setPicture('workshop')" v-model="otherArea">
                        <div class="input-group-append">
                            <span class="input-group-text">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="lot_area" class="col-lg-6">{{ $t('disposition.lot_area') }}</label>
                    <div class="input-group col-lg-6">
                        <input id="lot_area" class="form-control border-radius-0-right" min="0.01" step="0.01" type="number"
                               name="lot_area" v-on:focus="setPicture('lot')" v-model="lotArea">
                        <div class="input-group-append">
                            <span class="input-group-text">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>
            </div>
            <div id="parameters-thumb" class="col-md-6 focused-input-image d-none d-md-flex" v-if="type !== 'land'">
                <div v-if="displayCustomArea && this.type !== 'land'" class="position-absolute">
                    <valuo-custom-area :on-save="(newArea) => (floorArea = newArea)"></valuo-custom-area>
                </div>
                <object class="w-100" type="image/svg+xml" :data="assetsUrl + '/' + type + '/' + picture + '.svg'"></object>
            </div>
        </div>

    </div>
</template>

<script>
import Tooltip from "../../tooltip.vue";

export default {
    name: "Parameters",
    components: {Tooltip},

    props: ['assetsUrl', 'displayCustomArea'],

    data: function () {
        return {
            picture: 'nothing',
            floorArea: null,
            balconyArea: null,
            gardenArea: null,
            cellarArea: null,
            otherArea: null,
            garageArea: null,
            lotArea: null,
            data: {}
        }
    },

    computed: {
        type: function () {
            let type = this.$parent.getType();
            if (type == "cottage" || type == "hut") {
                type = "house";
            }

            this.picture = 'nothing';

            return type;
        },

        required: function () {
            return parseFloat(this.floorArea) != 'NaN' && parseFloat(this.floorArea) > 0;
        }
    },

    methods: {
        setPicture: function (picture) {
            let self = this
            if (picture !== self.picture) {
                let target = $("#parameters-thumb")
                target.fadeOut(500, function () {
                    self.picture = picture;
                    target.fadeIn(500, null);
                });
            }
        }
    },

    mounted: function () {
        this.data = this.$parent.oldData;

        this.floorArea = this.data.floor_area;
        this.balconyArea = this.data.balcony_area;
        this.gardenArea = this.data.garden_area;
        this.cellarArea = this.data.cellar_area;
        this.otherArea = this.data.other_area;
        this.lotArea = this.data.lot_area;
        this.garageArea = this.data.garage_area;
    }
}
</script>

<style scoped>
.focused-input-image {
    display: flex;
    align-items: center;
    justify-content: center;
}

.focused-input-image object {
    max-height: 250px;
    max-width: 380px;
}

@media (max-width: 1199px) {
    .parameters-flat .focused-input-image {
        padding: 0 50px;
    }
}

@media (max-width: 991px) {
    .parameters-flat .focused-input-image {
        padding: 0;
    }
}
</style>
